import React, { Component } from 'react'
import moment from 'moment'
import { Row, Col, Card, Radio, Checkbox, Button, Select, Icon, Modal, Spin, Popover } from 'antd'
import { app } from '../../app'
import asyncComponent from '../../components/asyncComponent'
import utils from '../../utils'
import { getOverview, getUseDetailsList } from './message_api'
import { getSMjoinTeamInfo, getSMBDInfo, getRule, postSMBDEdit, postSMjoinTeamEdit } from './message_api'
// import { color } from '_echarts@4.9.0@echarts/lib/theme/light'
import { indexOf } from 'underscore'


const BarReact = asyncComponent(() => import('../../components/Echarts'))  //统计图组件
// 单选框
const RadioGroup = Radio.Group
//多选框
const CheckboxGroup = Checkbox.Group
// 下拉选项
const Option = Select.Option

/**
 * 数值图表数据
 **/



// 组件内部
class MSset extends Component {
    constructor(props) {
        super(props)
        this.state = {

            time_type: '2',
            overview_loading: false,
            loadingFlag: false,
            teamInfo: props.team,
            // 生日短信自动发送开关
            birthdayMessageRadio: '开启',
            // 生日短信队员身份设置
            birthdayDefaultChecked: [],
            // 生日短信模板列表
            birthdayMessageTemplate: props.birthdayMessageTemplate,
            // 入队短信自动发送开关
            joinTeamMessageRadio: '开启',
            // 生日祝福模板信息
            // MessageTemplate : [],
            // 生日祝福默认选择的模板 -1代表着未选中
            defaultMessage: 0,
            // 入队通知模板信息
            joinTeamMessageTemplate: props.joinTeamMessageTemplate,
            defaultMessage2: 0,

            //这里的flag 要和 获取短信模板信息时的状态一致
            flag: 1,
            template_code: '',
            volunteer_state: '',
            //用于提交接口BDEdit 生日模块设置 的数据
            // 生日短信模板设置
            SMBDInfo: props.SMBDInfo,
            joinTeamEditInfo: props.joinTeamEditInfo,
            pggcj: 0

        }
        // this.createComponent()

    }

    createComponent = () => {

        this.getbriEditInfo()
        this.getjoiEditInfo()


    }


    //将短信设置数据从props中拿取，放到本组件中的state中去
    handleMessageInfo = () => {
        const { SMBDInfo, joinTeamEditInfo, birthdayMessageTemplate, joinTeamMessageTemplate } = this.props

        if (SMBDInfo.template_code != '') {
            this.setData({
                defaultMessage: SMBDInfo.templateIndex
            })
        }
        if (joinTeamEditInfo.template_code != '') {
            this.setData({
                defaultMessage2: joinTeamEditInfo.templateIndex
            })
        }
        this.setData({
            SMBDInfo, joinTeamEditInfo, birthdayMessageTemplate, joinTeamMessageTemplate
        })
    }


    // setData 自封装的函数
    setData = (data) => app.setStateSync(this, data)




    //生命周期
    componentDidMount() {
        this._isMounted = true
        //处理短信设置数据
        this.handleMessageInfo()


    }



    componentWillUnmount() {
        this._isMounted = false
        // console.log("俺呗终结了")
        this.setState({
            SMBDInfo: {}
        })
    }







    /**
     * 修改组件按钮
     **/
    handleChangeTime = async (e) => {
        const { value } = e.target
        const state = { time_type: value }
        this.setData(state)
        console.log(value)
        if (value == 1) {
            this.getbriEditInfo()
            this.setState({
                overview_loading: false
            })
        } else {
            this.getjoiEditInfo()
            this.setState({
                overview_loading: false
            })
        }
    }

    /**
     * 显示计算规则
     **/
    handleShowRule = async () => {
        let { rule_content } = this.state
        if (!rule_content) {
            app.alert('正在加载', 'loading', '45%', 0)
            rule_content = (await getRule()).content
            await this.setData({ rule_content })
            app.alertDestroy()
        }
        Modal.info({
            title: '短信计算规则',
            content: (
                <div style={{ height: '80vh', overflowY: 'auto' }} dangerouslySetInnerHTML={{ __html: rule_content }} />
            ),
            width: 700,
            centered: true
        })
    }











    // 生日短信模板开关
    onChange1 = e => {
        const SMBDInfo = this.state.SMBDInfo
        SMBDInfo.flag = e.target.value
        this.setData({
            SMBDInfo
        })
    };
    // 生日短信模板多选身份
    onchange2 = e => {
        const SMBDInfo = this.state.SMBDInfo
        SMBDInfo.volunteer_state = e
        this.setData({
            SMBDInfo
        });


    };

    onChange4 = e => {
        const SMBDInfo = this.state.SMBDInfo
        SMBDInfo.date_type = e.target.value
        console.log(e.target.value)
        this.setData({
            SMBDInfo
        });
    }

    // 生日短信模板下拉查看
    onSearch1 = e => {
        // getSMBDInfo(team).then(res => {
        //     const birthdayMessageTemplate = this.state.birthdayMessageTemplate
        //     birthdayMessageTemplate.forEach((item, index) => {
        //         if (item.template_code == res.template_code) {
        //             res.templateIndex = index
        //             this.setState({
        //                 SMBDInfo: res,
        //                 overview_loading: false

        //             })
        //         }
        //     })
        //     console.log(this.state.SMBDInfo)
        // })
        const SMBDInfo = this.state.SMBDInfo
        const birthdayMessageTemplate = this.state.birthdayMessageTemplate
        SMBDInfo.template_code = e
        birthdayMessageTemplate.forEach((item, index) => {
            if (item.template_code == e) {
                SMBDInfo.templateIndex = index
                this.setData({ defaultMessage: index, SMBDInfo })
            }
        })

    }



    //提交生日模板设置到服务器
    postBDEditMessage = async () => {

        const { SMBDInfo } = this.state
        const flag = SMBDInfo.flag
        console.log(SMBDInfo)

        if (flag == 1) {
            if (SMBDInfo.volunteer_state != '' && SMBDInfo.template_code != '' && SMBDInfo.date_type != 0) {
                if (typeof (SMBDInfo.volunteer_state) == 'string') {
                    const BDEdit = {
                        indexno: app.getData('indexno'),
                        account: app.getData('account'),
                        object_name: this.state.teamInfo.key,
                        flag: flag,
                        template_code: SMBDInfo.template_code,
                        volunteer_state: SMBDInfo.volunteer_state,
                        date_type: SMBDInfo.date_type
                    }
                    const msg = await postSMBDEdit(BDEdit);
                } else {
                    const BDEdit = {
                        indexno: app.getData('indexno'),
                        account: app.getData('account'),
                        object_name: this.state.teamInfo.key,
                        flag: flag,
                        template_code: SMBDInfo.template_code,
                        volunteer_state: SMBDInfo.volunteer_state.join(','),
                        date_type: SMBDInfo.date_type
                    }
                    const msg = await postSMBDEdit(BDEdit);

                    // const team = {
                    //     indexno: BDEdit.indexno,
                    //     account: BDEdit.account,
                    //     object_name: BDEdit.object_name,
                    // }
                    // const data = await getSMBDInfo(team)

                }

                // console.log(BDEdit)

            } else if (SMBDInfo.volunteer_state == '') {
                app.alert('请选择队员身份', 'error', '45%')
            } else if (SMBDInfo.template_code == '') {
                app.alert('请选择短信模板', 'error', '45%')
            } else {
                app.alert('请选择短信推送方式', 'error', '45%')

            }
        } else {
            const BDEdit = {
                indexno: app.getData('indexno'),
                account: app.getData('account'),
                object_name: this.state.teamInfo.key,
                flag: flag,
            }
            const msg = await postSMBDEdit(BDEdit);
        }



    }

    // postSMjoinTeamEdit

    // 入队短信模板开关
    onChange3 = e => {
        const joinTeamEditInfo = this.state.joinTeamEditInfo
        joinTeamEditInfo.flag = e.target.value
        this.setData({
            joinTeamEditInfo
        })
    }

    // 入队短信模板下拉查看
    onSearch2 = e => {
        // console.log(e)
        const joinTeamEditInfo = this.state.joinTeamEditInfo
        const joinTeamMessageTemplate = this.state.joinTeamMessageTemplate
        joinTeamEditInfo.template_code = e
        joinTeamMessageTemplate.forEach((item, index) => {
            if (item.template_code == e) {
                joinTeamEditInfo.templateIndex = index

                this.setData({ defaultMessage2: index, joinTeamEditInfo })
            }
        })

    }

    //提交入职模板设置到服务器
    postSMjoinTeamEditMessage = async () => {

        const { joinTeamEditInfo } = this.state
        const flag = joinTeamEditInfo.flag
        if (flag == 1) {
            if (joinTeamEditInfo.template_code != '') {
                // console.log("提交准备就绪了")
                const BDEdit = {
                    indexno: app.getData('indexno'),
                    account: app.getData('account'),
                    object_name: this.state.teamInfo.key,
                    flag: flag,
                    template_code: joinTeamEditInfo.template_code
                }
                const msg = await postSMjoinTeamEdit(BDEdit);


            } else {
                app.alert('请选择短信模板', 'error', '45%')
            }
        } else {
            const BDEdit = {
                indexno: app.getData('indexno'),
                account: app.getData('account'),
                object_name: this.state.teamInfo.key,
                flag: flag,
            }
            const msg = await postSMjoinTeamEdit(BDEdit);
        }
    }



    // 重新请求生日祝福设置
    getbriEditInfo = () => {
        this.setData({
            overview_loading: true
        })
        this.setData({
            pggcj: 2
        })
        console.log("正在重新请求生日")
        // 1.重新请求数据
        const team = {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            object_name: this.state.teamInfo.key,
        }
        getSMBDInfo(team).then(res => {
            const birthdayMessageTemplate = this.state.birthdayMessageTemplate
            birthdayMessageTemplate.forEach((item, index) => {
                if (item.template_code == res.template_code) {
                    res.templateIndex = index
                    this.setState({
                        SMBDInfo: res,
                        overview_loading: false
                    })
                }
            })


            this.setState({
                SMBDInfo: res,
                overview_loading: false
            })


            console.log(this.state.SMBDInfo)
        })



    }

    // 重新请求入队通知设置
    getjoiEditInfo = async () => {
        // console.log("正在重新请求入职")
        // joinTeamMessageTemplate
        // if(msti.type == 1){
        //     const team = {
        //         indexno: app.getData('indexno'),
        //         account: app.getData('account'),
        //         object_name: msti.key,
        //     }

        //     const data = await getSMjoinTeamInfo(team)
        //     const { MessageTemplate2 } = this.state
        //     if(MessageTemplate2 != ''){
        //         MessageTemplate2.forEach((item, index) => {
        //             if (item.template_code == data.template_code) {
        //                 data.templateIndex = index
        //             }
        //         })
        //     }

        //     this.setData({
        //         joinTeamEditInfo: data
        //     })
        // }
        this.setData({
            overview_loading: true
        })
        const team = {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            object_name: this.state.teamInfo.key,
        }
        const data = await getSMjoinTeamInfo(team)
        // console.log(data)


        const joinTeamMessageTemplate = this.state.joinTeamMessageTemplate
        // console.log(joinTeamMessageTemplate)
        joinTeamMessageTemplate.forEach((item, index) => {
            if (item.template_code == data.template_code) {
                data.templateIndex = index
            }
        })

        this.setState({
            joinTeamEditInfo: data,
            overview_loading: false
        })
    }



































    render() {
        console.log(this.state)
        let { time_type, SMBDInfo, joinTeamEditInfo, overview_loading, birthdayMessageTemplate, joinTeamMessageTemplate, loadingFlag } = this.state



        //第一个冒泡提示框内容
        const content1 = (
            <div>
                <p>开启自动发送短信功能，队伍必须先开通短信套餐（短信余量不能低于30条），否则无法发送短信</p>
            </div>
        )
        //第二个冒泡提示框内容
        const content2 = (
            <div>
                <p>按照选定的队员身份发送生日祝福短信</p>
            </div>
        )

        // 入队通知短信设置的提示框内容
        const content3 = (
            <div>
                <p>开启自动发送短信功能，队伍必须先开通短信套餐（短信余量不能低于30条），否则无法发送短信</p>
            </div>
        )

        // 短信推送方式设置
        const content4 = (
            <div>
                <p>短信推送方式设置须知：<br/>
                比如队员填写的生日是 1996-02-26，平台生日祝福推送方式如下（2021年为例）：<br/>
                1、按新历推送：2021-02-26 推送生日祝福短信<br/>
                2、按农历推送：2021-04-07（农历二月廿十六）推送生日祝福短信<br/>
                3、新历农历都推送：2021-02-26和2021-04-07都会推送生日祝福短信<br/>
                <br/>
                注：生日祝福短信推送方式由各队管理员设置<br/>
                </p>
            </div>
        )

        const birthdaySelect = (

            <Select
                showSearch
                style={{ width: 200 }}
                placeholder="请选择短信模板"
                optionFilterProp="label"
                onChange={this.onSearch1}
                defaultValue={(SMBDInfo.template_code != undefined ? SMBDInfo.template_code != '' : false) ? birthdayMessageTemplate[SMBDInfo.templateIndex].name : ''}
            >
                {birthdayMessageTemplate.map((item, index) =>
                    <Option key={item.id} value={item.template_code}>生日短信模板{index + 1}</Option>
                )}
            </Select>
        )



        // 生日祝福短信设置
        const birthdayMessage = (

            <div>

                <Spin spinning={overview_loading}>
                    <Row className="mop-number">
                        <Col span={8}>
                            <div className="pn-title">
                                {/* 开关按钮radio */}
                                <text style={{ color: 'red', marginRight: 2 }}>*</text>
                                自动发送：<RadioGroup options={[
                                    { label: '开启', value: '1' },
                                    { label: '关闭', value: '0' },
                                ]} onChange={this.onChange1} value={SMBDInfo.flag} />

                                <Popover content={content1} >
                                    <Icon type="question-circle" style={{ color: 'grey', fontSize: 14 }} />

                                </Popover>
                            </div>

                        </Col>
                    </Row>

                </Spin>
                <div hidden={SMBDInfo.flag == 1 ? false : true}>
                    <Spin spinning={loadingFlag}>
                        <Row className="mop-number">
                            <Col span={9}>
                                <div className="pn-title">
                                    {/* 身份选择checkbox */}
                                    <text style={{ color: 'red', marginRight: 2 }}>*</text>
                                    队员身份：<CheckboxGroup options={[
                                        { label: '正式队员', value: '1' },
                                        { label: '预备队员', value: '2' },
                                        { label: '认证志愿者', value: '3' },
                                        { label: '离队', value: '4' },
                                        { label: '清退', value: '5' },
                                        { label: '未设置身份', value: '0' },
                                    ]} value={SMBDInfo.volunteer_state} onChange={this.onchange2} />

                                    <Popover content={content2} >
                                        <Icon type="question-circle" style={{ color: 'grey', fontSize: 14 }} />

                                    </Popover>
                                </div>

                            </Col>
                        </Row>

                    </Spin>
                    <Spin spinning={loadingFlag}>
                        <Row className="mop-number">
                            <Col span={8}>
                                <div className="pn-title">
                                    <text style={{ color: 'red', marginRight: 2 }}>*</text>
                                    短信模板：
                                    {birthdaySelect}

                                </div>

                            </Col>
                        </Row>

                    </Spin>


                    <Spin spinning={loadingFlag}>
                        <Row className="mop-number">
                            <Col span={8}>
                                <div className="pn-title">
                                    {/* 开关按钮radio */}
                                    <text style={{ color: 'red', marginRight: 2 }}>*</text>
                                短信推送：<RadioGroup options={[
                                        { label: '按新历', value: '1' },
                                        { label: '按农历', value: '2' },
                                        { label: '新历农历都推送', value: '3' }
                                    ]} onChange={this.onChange4} value={SMBDInfo.date_type} />

                                    <Popover content={content4} >

                                        <Icon type="question-circle" style={{ color: 'grey', fontSize: 14 }} />
                                    </Popover>
                                </div>

                            </Col>
                        </Row>

                    </Spin>


                    {/* 三元表达式 */}
                    {
                        SMBDInfo.template_code != undefined ? <div>
                            <div style={{
                                width: 370,
                                height: 700,
                                position: 'absolute',
                                right: 380,
                                top: 60,
                            }}>
                                <div className="sx-phone-x">
                                    <div className="ex-mask" />
                                    <div className="ex-head">
                                        <div className="xh-1" />
                                        <div className="xh-2" />
                                    </div>
                                    <div className="ex-body">
                                        <div className="xb-content">
                                            <div className="bc-msg">【存心救援】{birthdayMessageTemplate[this.state.defaultMessage].template_content}</div>
                                            {
                                                birthdayMessageTemplate[this.state.defaultMessage].template_content ? (
                                                    <div className="bc-zhu">
                                                        <div>计费说明：当前内容字数为<b>{birthdayMessageTemplate[this.state.defaultMessage].template_content.length + 6}</b>，按照<b>{birthdayMessageTemplate[this.state.defaultMessage].template_content.length + 6 <= 70 ? 1 : 2}</b>条短信发送并计费。
                                        </div>
                                                        <div className="m-link" onClick={() => this.handleShowRule()}>查看短信计算规则</div>
                                                    </div>
                                                ) : null
                                            }
                                        </div>
                                    </div>
                                    <div className="ex-footer">
                                        <div className="xf-1" />
                                    </div>
                                    <div className="ex-info">
                                        <Icon type="info-circle" />
                                        <div>此功能仅作为内容预览，具体情况以实际发送为准</div>
                                    </div>
                                </div>
                            </div>
                        </div> : ''
                    }



                </div>

                {/* 提交按钮 */}
                <Button type="primary" style={{ width: 700, marginTop: 150 }} onClick={this.postBDEditMessage}>
                    提交
                    </Button>


                {/* 警告提示 */}
                <Spin spinning={loadingFlag}>
                    <Row className="mop-number">
                        <Col span={8}>
                            <div className="pn-title" style={{ color: '#F53503' }}>
                                {SMBDInfo.flag == 0 ? SMBDInfo.off_notice : SMBDInfo.on_notice}

                            </div>

                        </Col>
                    </Row>

                </Spin>
            </div>
        )




































        // 入队通知短信设置
        const joinTeamMessage = (
            <div>
                <Spin spinning={overview_loading}>
                    <Row className="mop-number">
                        <Col span={8}>
                            <div className="pn-title">
                                <text style={{ color: 'red', marginRight: 2 }}>*</text>
                                自动发送：<RadioGroup options={[
                                    { label: '开启', value: '1' },
                                    { label: '关闭', value: '0' },
                                ]} onChange={this.onChange3} value={joinTeamEditInfo.flag} />
                                {/* onChange={this.onChange1} value={this.state.birthdayMessageRadio} */}

                                <Popover content={content3} >
                                    <Icon type="question-circle" style={{ color: 'grey', fontSize: 14 }} />

                                </Popover>
                            </div>

                        </Col>
                    </Row>

                </Spin>

                <div hidden={joinTeamEditInfo.flag == 1 ? false : true}>
                    {/* joinTeamMessageTemplate */}
                    <Spin spinning={loadingFlag}>
                        <Row className="mop-number">
                            <Col span={8}>
                                <div className="pn-title">
                                    <text style={{ color: 'red', marginRight: 2 }}>*</text>
                                    短信模板：
                                    <Select
                                        showSearch
                                        style={{ width: 200 }}
                                        placeholder="请选择短信模板"
                                        optionFilterProp="label"
                                        onChange={this.onSearch2}
                                        defaultValue={(joinTeamEditInfo.template_code != undefined ? joinTeamEditInfo.template_code != '' : false) ? joinTeamMessageTemplate[joinTeamEditInfo.templateIndex].name : ''}
                                    >
                                        {joinTeamMessageTemplate.map((item, index) =>
                                            <Option key={item.id} value={item.template_code}>加入存心短信通知</Option>
                                        )}





                                    </Select>

                                </div>

                            </Col>
                        </Row>

                    </Spin>

                    {/* 三元表达式 */}
                    {/* {this.props.birthdayMessageTemplate[this.state.defaultMessage].template_content} */}
                    {
                        joinTeamEditInfo.template_code != undefined ? <div>
                            <div style={{
                                width: 370,
                                height: 700,
                                position: 'absolute',
                                right: 380,
                                top: 60,
                            }}>
                                <div className="sx-phone-x">
                                    <div className="ex-mask" />
                                    <div className="ex-head">
                                        <div className="xh-1" />
                                        <div className="xh-2" />
                                    </div>
                                    <div className="ex-body">
                                        <div className="xb-content">
                                            <div className="bc-msg">【存心救援】{joinTeamMessageTemplate[this.state.defaultMessage2].template_content}</div>
                                            {
                                                joinTeamMessageTemplate[this.state.defaultMessage2].template_content ? (
                                                    <div className="bc-zhu">
                                                        <div>计费说明：当前内容字数为<b>{joinTeamMessageTemplate[this.state.defaultMessage2].template_content.length + 6}</b>，按照<b>{joinTeamMessageTemplate[this.state.defaultMessage2].template_content.length + 6 <= 70 ? 1 : 2}</b>条短信发送并计费。
                                        </div>
                                                        <div className="m-link" onClick={() => this.handleShowRule()}>查看短信计算规则</div>
                                                    </div>
                                                ) : null
                                            }
                                        </div>
                                    </div>
                                    <div className="ex-footer">
                                        <div className="xf-1" />
                                    </div>
                                    <div className="ex-info">
                                        <Icon type="info-circle" />
                                        <div>此功能仅作为内容预览，具体情况以实际发送为准</div>
                                    </div>
                                </div>
                            </div>
                        </div> : ''
                    }

                </div>



                {/* 提交按钮 */}
                <Button type="primary" style={{ width: 700, marginTop: 150 }} onClick={this.postSMjoinTeamEditMessage}>
                    提交
                    </Button>


                {/* 警告提示 */}
                <Spin spinning={loadingFlag}>
                    <Row className="mop-number">
                        <Col span={8}>
                            <div className="pn-title" style={{ color: '#F53503' }}>

                                {joinTeamEditInfo.flag == 0 ? joinTeamEditInfo.off_notice : joinTeamEditInfo.on_notice}
                            </div>

                        </Col>
                    </Row>

                </Spin>
            </div>
        )


        return (
            <div className="message-overview-page">
                {/* 顶部title栏 */}
                <Card size="small" headStyle={{ backgroundColor: '#F5F6FA' }} bodyStyle={{ padding: 25 }}
                    title="短信自动发送设置"
                >

                    <Row type="flex" align="middle">
                        <Radio.Group value={time_type} buttonStyle="solid" className="no-select"
                            onChange={(e) => this.handleChangeTime(e)}>
                            {/* <Radio.Button value="1" >生日祝福短信设置</Radio.Button> */}
                            <Radio.Button value="2" >入队通知短信设置</Radio.Button>
                        </Radio.Group>

                    </Row>
                    {/* 三元表达 */}
                    {
                        time_type == 1 ? birthdayMessage : joinTeamMessage
                    }


                </Card>



            </div>
        )
    }
}

export default MSset



// WEBPACK FOOTER //
// ./src/routes/message/MSset.jsx